var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overlay-scrollbars',{ref:"os",staticClass:"page page-accounts"},[_vm._v(" Settings "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"btn btn_change_password",on:{"click":_vm.showChangePassword}},[_vm._v("Change password")])])])}
var staticRenderFns = []

export { render, staticRenderFns }